import { render } from "./storeSocialLinks.vue?vue&type=template&id=53777968&scoped=true"
import script from "./storeSocialLinks.vue?vue&type=script&lang=js"
export * from "./storeSocialLinks.vue?vue&type=script&lang=js"

import "./storeSocialLinks.vue?vue&type=style&index=0&id=53777968&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53777968"]])

export default __exports__